import { TemplateContent, TemplateHeader, TemplateLayout } from '../styled';

interface Props {
  children: React.ReactNode;
}

function Template({ children }: Props) {
  return (
    <TemplateLayout>
      <TemplateHeader justify="center" align="center">
        External Community
      </TemplateHeader>
      <TemplateContent>{children}</TemplateContent>
    </TemplateLayout>
  );
}

export default Template;
